import { render, staticRenderFns } from "./PlotEditSP.vue?vue&type=template&id=c4b9dfd4&scoped=true&"
import script from "./PlotEditSP.vue?vue&type=script&lang=ts&"
export * from "./PlotEditSP.vue?vue&type=script&lang=ts&"
import style0 from "./PlotEditSP.vue?vue&type=style&index=0&id=c4b9dfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b9dfd4",
  null
  
)

export default component.exports